import { render } from "./Records.vue?vue&type=template&id=751f0160&scoped=true&ts=true"
import script from "./Records.vue?vue&type=script&lang=ts"
export * from "./Records.vue?vue&type=script&lang=ts"

import "./Records.vue?vue&type=style&index=0&id=751f0160&lang=css"
import "./Records.vue?vue&type=style&index=1&id=751f0160&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/dev.poct.nikted.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-751f0160"]])

export default __exports__